import dataSources from 'dataSources';
import { batch } from 'react-redux';
import { AppThunk } from 'store';
import { STATUS_LOADING } from 'common/constants';
import { getResponseError } from 'common/utils/index';

import slice from '../reducer/slice';
import appSlice from '../../application/reducer/slice';
import { mapCardsById } from 'store/features/fuelCards/utils';
import getUrlParam from 'common/utils/url/getURLParam';
import { URL_PARAMS } from 'common/constants/url';
import { LOCAL_STORAGE_KEY } from 'pages/Map/context/fuelCards';

type TOperation = () => AppThunk;

const { setFuelCardsStatusLoading, setFuelCards, setActiveFuelCard } =
  slice.actions;
const { setError } = appSlice.actions;

const operation: TOperation = () => async (dispatch) => {
  try {
    batch(() => {
      dispatch(setFuelCardsStatusLoading(STATUS_LOADING.load));
    });
    const data = await dataSources.fuelCards.getFuelCards();

    batch(() => {
      const fuelCardsData = mapCardsById(data.cards);

      dispatch(setFuelCards(fuelCardsData));

      const cardNumberInLocationOrStorage =
        getUrlParam(URL_PARAMS.fuelCardnumber) ||
        window.localStorage.getItem(LOCAL_STORAGE_KEY) ||
        '';

      if (fuelCardsData[cardNumberInLocationOrStorage]) {
        dispatch(setActiveFuelCard(cardNumberInLocationOrStorage));
        window.localStorage.setItem(
          LOCAL_STORAGE_KEY,
          cardNumberInLocationOrStorage,
        );
      } else {
        window.localStorage.removeItem(LOCAL_STORAGE_KEY);
      }

      dispatch(setFuelCardsStatusLoading(STATUS_LOADING.done));
    });
  } catch (e) {
    console.info(e);
    const error = await getResponseError(e);
    dispatch(setError(error));
    dispatch(setFuelCardsStatusLoading(STATUS_LOADING.done));
  } finally {
    dispatch(setFuelCardsStatusLoading(STATUS_LOADING.done));
  }
};

export default operation;
